import { ObjectState } from "../../../containers/centralView/taskListView/types/tasklListViewProps"
import { FormComment, krFormTypes, LandSlideDocuments, LandslidePublications, KrEndangeredAreaFormTypes, KrLandslideFormTypes, MonitoringAttachments, MonitoringRegisters } from "../../../contexts/krFormContext"
import { poFormTypes, RastersAttributes } from "../../../contexts/poFormContext"
import { ObjectType } from "../../../contexts/types/card"
import { Dictionary } from "../../../helpers/dictionariesFromLayers";

export type RegistrationCardIds = {
    Type: string,
    Id: string,
    cardPattern: number,
    globalId: string
}

export type RegistrationCardProperties = {
    Type: string,
    cardPattern: string
}

export type QueryDocumentsProps = {
    landslideDocuments: LandSlideDocuments
    apiBase: string
}

export type QueryPublicationsProps = {
    landslidePublications: LandslidePublications
    apiBase: string
}

export type AddRegistrationCardRastersProps = {
    rastersAttributes: RastersAttributes[]
    objectIdNumber: number
    isLandslide: boolean
    waitingRoomGlobalId?: string
    filePath: string
    apiBase: string
}

export type AddRegistrationCardMonitoringProps = {
    monitoring: MonitoringRegisters
    monitoringAttachments: MonitoringAttachments[]
    objectIdNumber: number
    waitingRoomGlobalId?: string
    filePath: string
    apiBase: string
}

export type SaveRegistrationCardProps = {
    form: krFormTypes
    state?: string
    objectType: string
    apiBase: string,
    validationStatus?: string
}

export type SaveRegistrationCardCommentsProps = {
    comments?: FormComment[],
    waitingRoomId: number,
    apiBase: string
}

export type ValidateSelectedCardsProps = {
    waitingRoomGids: string[]
    apiBase: string
    isVerifier: boolean
}

export type CardsValidationProps = {
    waitingRoomIds: string[],
    apiBase: string
}

export type StatusValidationCardProps = {
    waitingRoomAttr: CardsVaildationRequest[],
    apiBase: string
}

export type CardsVaildationRequest = {
    waitingRoomId?: string,
    isValid?: number
};

export type Cards = {
    populateLandslideCardResponse: KrLandslideFormTypes[],
    populateEndangeredAreaCardResponse: KrEndangeredAreaFormTypes[],
    populateProtocolFormResponse: poFormTypes[],
    dictionariesForValidation?: Dictionary
}

export type CardStateUpdate = {
    gid?: string,
    state?: string
}

export type CardReturn = {
    krForm?: string,
    state?: ObjectState,
    status?: string,
    krType?: ObjectType,
    idNumber?: string
}

export type ObjectsReturn = {
    cards?: CardReturn[],
    userToken?: string
}

export type CheckEditor = {
    cards?: CardStateUpdate[],
    userToken?: string
}

export type GetPdfCardProps = {
    waitingRoomGid?: string
}

export type CardsDownloadProps = {
    downloadMode: CardDownloadMode,
    waitingRoomRecs: any[],
    apiBase: string
}

export enum CardDownloadMode {
    "Edit",
    "Verification",
    "EditAndVerification"
}